import React from "react";
import styles from "./SearchBoxReadout.module.scss";
import AccessibilityLabel from "@unum/accessibility-label";
import Button from "@unum/button";
import MicroCopy from "@unum/micro-copy";

type Props = {
  searchTerm: string;
  onReset: () => void;
};

const SearchBoxReadout = ({ searchTerm, onReset }: Props) => {
  if (!searchTerm) {
    return null;
  }

  return (
    <span className={styles["SearchBoxReadout"]}>
      <MicroCopy
        path="search.readout"
        placeholders={{
          searchTerm
        }}
      />
      <Button className={styles["button"]} theme="close" onClick={onReset}>
        <AccessibilityLabel>
          <MicroCopy
            path="search.readout.clear.screen-reader"
            placeholders={{ searchTerm }}
          />
        </AccessibilityLabel>
      </Button>
    </span>
  );
};

export default SearchBoxReadout;
